import type { documentSchema } from '@ecomm/contentful-schemas'
import type { HeroBannerColumnSchema } from '@ecomm/shared-components/lib/HeroBanner/schema'
import {
  type JSONObject,
  substituteVariable
} from '@ecomm/utils/substituteVariableJson'
import type { TypeOf } from '@simplisafe/ewok'
type DocumentSchema = TypeOf<typeof documentSchema>

export const modifyDescription = (
  heroBannerColumn: HeroBannerColumnSchema,
  location: string
): DocumentSchema => {
  return <DocumentSchema>(
    (<unknown>(
      substituteVariable(
        <JSONObject>(<unknown>heroBannerColumn.description.json),
        'location',
        location
      )
    ))
  )
}
